import { useAuthStore } from "@/stores/useAuthStore"
import { useQueryClient } from "@tanstack/react-query"
import { useRouter } from "@tanstack/react-router"

export const useLogout = () => {
  const router = useRouter()
  const queryClient = useQueryClient()
  const authStoreLogout = useAuthStore((state) => state.logout)

  const logout = () => {
    authStoreLogout()

    Promise.resolve().then(() => queryClient.clear())
    router.navigate({ to: "/login" })
  }

  return { logout }
}
